import { useEffect, useState } from 'react';
import io from '@common/services/featherIO/feathers.io';
import { useDispatch } from 'react-redux';
import {
  checkAuthError,
  checkAuthSuccess,
  signOut,
} from '@common/redux/slice/auth';

const useSocketConnection = () => {
  const [loading, setLoading] = useState(true);
  const dispatch = useDispatch();

  useEffect(() => {
    (async () => {
      setLoading(true);
      await io
        .reAuthenticate()
        .then((data) => {
          const { userPreview: auth, accessToken } = data;
          if (auth) {
            console.log('===Check Auth Success!');
            dispatch(
              checkAuthSuccess(Object.assign({}, auth, { accessToken }))
            );
          } else {
            console.log('===Check Auth Error: Default Token!');
            dispatch(checkAuthError());
          }
        })
        .catch(async (error) => {
          // io.logout() also hits the network; while offline it rejects too.
          // Swallow it here so it doesn't surface as an unhandled rejection
          // (which can crash the app in release builds).
          try {
            await io.logout();
          } catch (logoutError) {
            console.log('===Logout after auth error failed: ', logoutError);
          }
          dispatch(checkAuthError());
          console.log('===Check Auth Error: ', error);
        })
        .finally(() => {
          setLoading(false);
        });
    })();
  }, [dispatch]);

  useEffect(() => {
    const handleAuthFailure = () => {
      dispatch(signOut({}));
      io.logout();
    };
    io.on('authFailure', handleAuthFailure);

    return () => {
      io.removeListener('authFailure', handleAuthFailure);
    };
  }, [dispatch]);

  return {
    loading,
  };
};

export default useSocketConnection;
